import { FC, ButtonHTMLAttributes } from 'react'
import { Button } from '@/root/ui/shared/Button/Button'
import Loader from '@/root/ui/shared/Loader/Loader'
import { AgreeIcon } from '@/root/ui/shared/icons/AgreeIcon'

interface SaveButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string
  loading?: boolean
}

export const SaveButton: FC<SaveButtonProps> = ({ title, loading, disabled, ...props }) => (
  <Button type="submit" variant="contained" className="h-9 w-40 text-base" disabled={loading || disabled} {...props}>
    <div className="flex items-center justify-center gap-2">
      {loading ? <Loader className="size-4" /> : <AgreeIcon width={16} />}
      <div>{title}</div>
    </div>
  </Button>
)
